// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"36f64641","242":"0ad8449e","628":"3177b1ce","844":"ee347d18"}[chunkId] + ".css";
};